/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContractDetailsDtoApiResponse } from '../../models/contract-details-dto-api-response';
import { EditContractCommand } from '../../models/edit-contract-command';

export interface EditContractAsync$Plain$Params {
  id: number;
      body?: EditContractCommand
}

export function editContractAsync$Plain(http: HttpClient, rootUrl: string, params: EditContractAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ContractDetailsDtoApiResponse>> {
  const rb = new RequestBuilder(rootUrl, editContractAsync$Plain.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContractDetailsDtoApiResponse>;
    })
  );
}

editContractAsync$Plain.PATH = '/api/contract/{id}';
